import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { AnimateOnScrollDirective } from '../../directives/animate-on-scroll.directive';

interface TeamMember {
  key: string;
  image: string;
}

@Component({
    selector: 'app-team',
    imports: [TranslateModule, AnimateOnScrollDirective],
    templateUrl: './team.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./team.component.scss']
})
export class TeamComponent {
  teamMembers: TeamMember[] = [
    { key: 'carlos_taborda', image: 'assets/images/person1.png' },
    { key: 'carlos_gonzales', image: 'assets/images/person2.png' }
  ];
} 